import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Projects from '../components/Projects';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { useSeo } from '../hooks/useSeo';
import './LandingPage.css';
import './ProjectsPage.css';

const GROUPS = ['demo', 'production'];
// Every demo is a website, so category never applies there.
const FACETS = { demo: ['industry'], production: ['industry', 'category'] };

/*
 * The full catalogue. The home page shows a shortlist; this is where the
 * filters live. The chosen group sits in the query string, so a link to the
 * client-work view can be shared.
 */
function ProjectsPage() {
  useSeo('projectsPage.seo');
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const group = GROUPS.includes(params.get('type')) ? params.get('type') : GROUPS[0];

  const choose = (next) =>
    setParams(next === GROUPS[0] ? {} : { type: next }, { replace: true });

  return (
    <div className="landing-page">
      <Navigation />

      <header className="projects-page-head">
        <p className="section-eyebrow">{t('projectsPage.eyebrow')}</p>
        <h1 className="projects-page-title">
          <Trans i18nKey="projectsPage.title" components={{ em: <em /> }} />
        </h1>
        <p className="projects-page-desc">{t('projectsPage.desc')}</p>

        <div className="group-switch" role="group" aria-label={t('projectsPage.switchLabel')}>
          {GROUPS.map(value => (
            <button
              key={value}
              type="button"
              aria-pressed={group === value}
              className={`group-switch-btn ${group === value ? 'active' : ''}`}
              onClick={() => choose(value)}
            >
              {t(`projectsPage.groups.${value}`)}
            </button>
          ))}
        </div>
      </header>

      {/* keyed by group so filter selections don't leak between the two lists */}
      <Projects key={group} group={group} facets={FACETS[group]} />

      <Contact />
      <Footer />
    </div>
  );
}

export default ProjectsPage;
